<template>
  <div class="sort">
    <div class="sort-box">
      <!-- <div class="sort-top" :class="{'actice':!btnActive}">
                <i class="el-icon-caret-top"></i>
      </div>-->
      <div class="sort-bottom" :class="{'styleColor':!styleColor}">
        <i :class="{'el-icon-caret-bottom':btnActive}"></i>
        <i :class="{'el-icon-caret-top':!btnActive}"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    btnActive: {
      type: Boolean,
      default: true
    },
    styleColor: Boolean
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.sort {
  display: inline-block;
  height: 100%;
  margin-left: 2px;
  color: #237dc9;
  font-size: 16px;
  .sort-box {
    display: flex;
    flex-direction: column;
  }
  .sort-top {
    height: 12px;
    display: flex;
    align-items: center;
  }
  .sort-bottom {
    height: 12px;
    display: flex;
    align-items: center;
  }
}
.styleColor {
  color: #666;
}
</style>